var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "arrow-right_svg__svg-icon",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "arrow-right_svg__arrow-right"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5 13h11.17l-4.88 4.88c-.39.39-.39 1.03 0 1.42s1.02.39 1.41 0l6.59-6.59a.996.996 0 0 0 0-1.41l-6.58-6.6a.996.996 0 1 0-1.41 1.41L16.17 11H5c-.55 0-1 .45-1 1s.45 1 1 1",
    className: "arrow-right_svg__vector"
  }))));
};
export { SvgArrowRight as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9Im5vbmUiIHZpZXdCb3g9IjAgMCAyNCAyNCIgY2xhc3M9InN2Zy1pY29uIiByb2xlPSJpbWciPjx0aXRsZT5BcnJvdyBSaWdodDwvdGl0bGU+PGcgY2xhc3M9ImFycm93LXJpZ2h0Ij48cGF0aCBmaWxsPSJjdXJyZW50Q29sb3IiIGQ9Ik01IDEzaDExLjE3bC00Ljg4IDQuODhjLS4zOS4zOS0uMzkgMS4wMyAwIDEuNDIuMzkuMzkgMS4wMi4zOSAxLjQxIDBsNi41OS02LjU5YS45OTYuOTk2IDAgMCAwIDAtMS40MWwtNi41OC02LjZhLjk5Ni45OTYgMCAxIDAtMS40MSAxLjQxTDE2LjE3IDExSDVjLS41NSAwLTEgLjQ1LTEgMXMuNDUgMSAxIDFaIiBjbGFzcz0idmVjdG9yIi8+PC9nPjwvc3ZnPg==";